import React from "react";
import { StyledParagraph, StyledLink } from "../styles/Typography.styled";
import { ProjectsContainer, StyledProjects } from "../styles/Projects.styled";
import { SectionHeading, SectionTitle } from "../styles/SectionHeading";
import { projectData } from "./projectsData";
import ProjectCardComponent from "./ProjectCard";
import Marquee from "react-fast-marquee";

const Projects = () => {
  // Assuming you have some way to select two fixed projects from projectData
  const fixedProjects = projectData.slice(0, 2); // Get first two projects as fixed

  const otherProjects = projectData.slice(2); // Get remaining projects for marquee

  return (
    <StyledProjects id="projects">
      <SectionHeading>
        <SectionTitle number="04">Projects</SectionTitle>
      </SectionHeading>
      <StyledParagraph dark="true" textAlign="center">
        Selected projects I've worked on recently.{" "}
        <StyledLink
          href="https://github.com/Abhii-07"
          target="_blank"
          rel="noopener noreferrer"
        >
          Want to see more?
        </StyledLink>
      </StyledParagraph>

      {/* Fixed Projects */}
      <ProjectsContainer>
        {projectData.map((project) => (
          <ProjectCardComponent key={project.id} {...project} />
        ))}
      </ProjectsContainer>

      {/* Marquee for other Projects
      <Marquee pauseOnHover="true">
        {otherProjects.map((project) => (
          <ProjectCardComponent key={project.id} {...project} />
        ))}
      </Marquee> */}
    </StyledProjects>
  );
};

export default Projects;
